import {promisifyModal} from 'common/components/modal/utils';
import type {CustomEventDefinition} from 'common/report/util/saved-entities/types';
import {Visibility} from 'common/components/base/stackable';

export async function promptCustomEvents(
  attrs,
): Promise<{appliedValue: CustomEventDefinition; didClose: boolean; deletedId: string | number}> {
  const closeEv = await promisifyModal({
    tagName: `mp-custom-event-modal`,
    attrs,
    closeEvents: [`savedCustomEvent`, `deletedCustomEvent`, `modalClosed`],
  });

  return {
    appliedValue: closeEv.type === `savedCustomEvent` ? closeEv.detail?.customEvent : null,
    didClose:
      closeEv.type === `modalClosed` || (closeEv.type === `change` && closeEv.detail.state === Visibility.Closed),
    deletedId: closeEv.type === `deletedCustomEvent` ? closeEv.detail.id : null,
  };
}
